import BaseService from './BaseService';

export default class SettingService extends BaseService {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'settings';
        this.getValue = this.getValue.bind(this);
    }

    getValue(key) {
    	return this.fetch(`${this.domain}/${this.path}/key/` + key, {
    		method: 'GET',
    	}).catch((err) => {
    		throw err;
    	});
    }

    getCaptchaPublic() {
        return this.fetch(`${this.domain}/${this.path}/captcha`, {
            method: 'GET',
        })
            .then((res) => {
                return Promise.resolve(res);
            })
            .catch((err) => {
                throw err;
            });
    }

    getVersionInfo() {
        return this.fetch(`${this.domain}/${this.path}/version`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }
    getPasswordParamsPublic() {
        return this.fetch(`${this.domain}/${this.path}/passwords-params`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }
    getAppLinkUrl() {
        return this.fetch(`${this.domain}/${this.path}/app-url`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }
    getFuelRanges() {
        return this.fetch(`${this.domain}/${this.path}/fuel-ranges`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }
    getTelephoneCodeList() {
        return this.fetch(`${this.domain}/${this.path}/telephone-codes`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }

    getProvinceList() {
        return this.fetch(`${this.domain}/${this.path}/provinces`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }

    getVehicleTypes() {
        return this.fetch(`${this.domain}/${this.path}/vehicle-types`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }

    getVehicleCategories() {
        return this.fetch(`${this.domain}/${this.path}/vehicle-categories`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }
}
